/* CSBH Shop by Region — interactive map (Leaflet + markercluster).
   Data: map-data.json (products with lat/lng, maker fallthrough already applied)
   and map-world.json (trimmed Natural Earth countries, brand-styled layer).
   v2: pins always visible (inline-styled icon); country click NAVIGATES (no pin
   filtering); floating in-view pill (top-left); viewport-driven product grid
   below the map. Search still filters pins + grid. */
(function () {
  var root = document.getElementById('csbh-map-root');
  if (!root || typeof L === 'undefined') return;

  Promise.all([
    fetch(root.dataset.productsUrl).then(function (r) { return r.json(); }),
    fetch(root.dataset.worldUrl).then(function (r) { return r.json(); }),
    root.dataset.statesUrl
      ? fetch(root.dataset.statesUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
      : Promise.resolve(null)
  ]).then(function (loaded) { init(loaded[0], loaded[1], loaded[2]); })
    .catch(function (err) { console.error('[csbh-map] data load failed', err); });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(products, world, states) {
    var state = { query: '' };

    /* ---------- map ---------- */
    var map = L.map(root.querySelector('.csbh-map-canvas'), {
      zoomControl: false,
      scrollWheelZoom: true,
      dragging: true,
      worldCopyJump: false,
      minZoom: 2,
      maxZoom: 7,
      maxBounds: [[-58, -185], [78, 185]],
      maxBoundsViscosity: 0.8,
      attributionControl: true,
      gestureHandling: true, /* no-op unless leaflet-gesture-handling registered the handler */
      gestureHandlingOptions: { duration: 1200, text: {
        touch: 'Use two fingers to move the map',
        scroll: 'Use ctrl + scroll to zoom the map',
        scrollMac: 'Use \u2318 + scroll to zoom the map' } }
    });
    L.control.zoom({ position: 'bottomright' }).addTo(map);
    map.attributionControl.setPrefix(false);
    map.attributionControl.addAttribution('Map data: Natural Earth');
    root._map = map; // QA hook

    var hasCountry = {};
    products.forEach(function (p) { if (p.country) hasCountry[p.country] = true; });

    L.geoJSON(world, {
      style: function (f) {
        var has = hasCountry[f.properties.NAME_NORM];
        return {
          fillColor: has ? '#ECE2C7' : '#F5F1E8',
          fillOpacity: 1,
          color: '#C8BFA6',
          weight: 0.7
        };
      },
      onEachFeature: function (f, layer) {
        var name = f.properties.NAME_NORM;
        if (!hasCountry[name]) return;
        layer.on('click', function () { focusCountry(name); });
        layer.on('mouseover', function () { layer.setStyle({ fillColor: '#E5D8B4' }); });
        layer.on('mouseout', function () { layer.setStyle({ fillColor: '#ECE2C7' }); });
      }
    }).addTo(map);

    if (states) {
      L.geoJSON(states, {
        interactive: false,
        style: { fill: false, color: '#B5AB8F', weight: 0.6, dashArray: '2 3', opacity: 0.8 }
      }).addTo(map);
    }

    /* ---------- home marker: The Cheese Store of Beverly Hills ---------- */
    if (root.dataset.fleurUrl) {
      var homeIcon = L.divIcon({
        className: '',
        html: '<img src="' + esc(root.dataset.fleurUrl) + '" style="width:46px;height:auto;display:block;filter:brightness(0) saturate(100%) invert(62%) sepia(31%) saturate(500%) hue-rotate(357deg) brightness(95%) contrast(87%) drop-shadow(0 2px 5px rgba(0,0,0,0.3));" alt="The Cheese Store of Beverly Hills">',
        iconSize: [46, 54],
        iconAnchor: [23, 27]
      });
      L.marker([34.0673, -118.4035], { icon: homeIcon, zIndexOffset: -1000, title: 'The Cheese Store of Beverly Hills' })
        .addTo(map)
        .bindPopup('<div class="csbh-map-pop"><div class="csbh-map-pop-body">' +
          '<div class="csbh-map-pop-title">The Cheese Store of Beverly Hills</div>' +
          '<div class="csbh-map-pop-place">9705 S Santa Monica Blvd · Beverly Hills</div>' +
          '<a class="csbh-map-pop-link" href="/pages/contact">Visit us &rarr;</a></div></div>');
    }

    /* ---------- markers (pin styled inline — never depends on stylesheet) ---------- */
    var cluster = L.markerClusterGroup({
      maxClusterRadius: 38,
      showCoverageOnHover: false,
      spiderfyOnMaxZoom: true,
      iconCreateFunction: function (c) {
        var n = c.getChildCount();
        var size = n < 10 ? 32 : n < 40 ? 40 : 48;
        return L.divIcon({
          html: '<div class="csbh-map-cluster" style="width:' + size + 'px;height:' + size + 'px;">' + n + '</div>',
          className: '',
          iconSize: [size, size]
        });
      }
    });
    map.addLayer(cluster);

    var pinIcon = L.divIcon({
      className: '',
      html: '<svg class="csbh-map-pin" width="18" height="18" viewBox="0 0 18 18" style="display:block;overflow:visible;">' +
        '<circle cx="9" cy="9" r="6.5" fill="#B20A70" stroke="#ffffff" stroke-width="2.5"/>' +
        '<circle cx="9" cy="9" r="8" fill="none" stroke="#8A0858" stroke-width="1"/></svg>',
      iconSize: [18, 18],
      iconAnchor: [9, 9]
    });

    products.forEach(function (p) {
      p._marker = L.marker([p.lat, p.lng], { icon: pinIcon, title: p.title });
      p._marker.bindPopup(function () { return popupHtml(p); }, { closeButton: true });
    });

    function popupHtml(p) {
      var place = [p.town, p.region, p.country].filter(Boolean).join(' · ');
      var img = p.img ? '<a href="/products/' + esc(p.handle) + '" aria-label="' + esc(p.title) + '"><img src="' + esc(p.img) + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=480" alt="' + esc(p.title) + '" loading="lazy"></a>' : '';
      return '<div class="csbh-map-pop">' + img +
        '<div class="csbh-map-pop-body">' +
        '<div class="csbh-map-pop-title">' + esc(p.title) + '</div>' +
        (place ? '<div class="csbh-map-pop-place">' + esc(place) + '</div>' : '') +
        '<a class="csbh-map-pop-link" href="/products/' + esc(p.handle) + '">View cheese &rarr;</a>' +
        '</div></div>';
    }

    /* ---------- search filter (the only thing that hides pins) ---------- */
    function visible() {
      var q = state.query.toLowerCase();
      if (!q) return products;
      return products.filter(function (p) {
        return (p.title + ' ' + p.country + ' ' + p.region + ' ' + p.town).toLowerCase().indexOf(q) > -1;
      });
    }

    function boundsOf(list) {
      return L.latLngBounds(list.map(function (p) { return [p.lat, p.lng]; }));
    }

    function render(fit) {
      var vis = visible();
      cluster.clearLayers();
      vis.forEach(function (p) { cluster.addLayer(p._marker); });
      if (fit && vis.length) {
        map.fitBounds(boundsOf(vis), { padding: [50, 50], maxZoom: 7 });
      }
      renderResults(vis);
      updateScope();
    }

    /* ---------- navigation (country/region click = fly there, pins stay) ---------- */
    function focusCountry(c) {
      var list = products.filter(function (p) { return p.country === c; });
      if (list.length) map.flyToBounds(boundsOf(list), { padding: [60, 60], maxZoom: 6, duration: 0.8 });
      openCountry = c;
      refreshBrowse();
    }
    function focusRegion(c, r) {
      var list = products.filter(function (p) {
        return p.country === c && (p.region || 'Other') === r;
      });
      if (list.length) map.flyToBounds(boundsOf(list), { padding: [70, 70], maxZoom: 7, duration: 0.8 });
    }

    /* ---------- in-view pill + product grid (viewport-driven) ---------- */
    var pill = root.querySelector('.csbh-map-viewpill');
    var grid = root.querySelector('.csbh-map-grid');
    var gridLabel = root.querySelector('.csbh-map-gridlabel');
    var scopeList = root.querySelector('.csbh-map-scope-list');
    var scopeTitle = root.querySelector('.csbh-map-scope-title');
    var scopeReset = root.querySelector('.csbh-map-scope-reset');
    if (scopeReset) scopeReset.addEventListener('click', function () {
      map.fitBounds(boundsOf(products), { padding: [40, 40] });
    });
    if (pill && root.querySelector('.csbh-map-panel')) pill.style.left = '380px';
    if (pill) pill.addEventListener('click', function () {
      map.fitBounds(boundsOf(products), { padding: [40, 40] });
    });

    function updateScope() {
      if (!grid) return;
      var b = map.getBounds();
      var inview = visible().filter(function (p) { return b.contains([p.lat, p.lng]); });

      var counts = {};
      inview.forEach(function (p) { var c = p.country || 'Other'; counts[c] = (counts[c] || 0) + 1; });
      var dom = null;
      Object.keys(counts).forEach(function (c) { if (!dom || counts[c] > counts[dom]) dom = c; });

      if (pill) {
        if (inview.length && dom && counts[dom] / inview.length >= 0.55) {
          pill.hidden = false;
          pill.querySelector('span').innerHTML = esc(dom) + ' &middot; ' + counts[dom] + ' in view';
        } else if (inview.length) {
          pill.hidden = false;
          pill.querySelector('span').textContent = inview.length + ' cheeses in view';
        } else {
          pill.hidden = true;
        }
      }

      if (gridLabel) {
        gridLabel.textContent = inview.length
          ? 'In view · ' + inview.length + ' cheese' + (inview.length === 1 ? '' : 's')
          : 'Pan or zoom the map to see cheeses here';
      }

      function makeCard(p) {
        var place = [p.town, p.region].filter(Boolean).join(', ') || p.country || '';
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'csbh-map-card';
        card.innerHTML =
          (p.img
            ? '<img src="' + esc(p.img) + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">'
            : '<span class="csbh-map-card-noimg"></span>') +
          '<span class="csbh-map-card-txt"><span class="csbh-map-card-t">' + esc(p.title) + '</span>' +
          (place ? '<span class="csbh-map-card-p">' + esc(place) + '</span>' : '') + '</span>';
        card.addEventListener('click', function () {
          map.flyTo([p.lat, p.lng], Math.max(map.getZoom(), 6), { duration: 0.6 });
          map.once('moveend', function () {
            cluster.zoomToShowLayer(p._marker, function () { p._marker.openPopup(); });
          });
        });
        return card;
      }
      function fill(el, cap) {
        if (!el) return;
        el.innerHTML = '';
        inview.slice(0, cap).forEach(function (p) { el.appendChild(makeCard(p)); });
        if (inview.length > cap) {
          var more = document.createElement('div');
          more.className = 'csbh-map-card csbh-map-card-more';
          more.textContent = '+ ' + (inview.length - cap) + ' more — zoom in to narrow';
          el.appendChild(more);
        }
      }
      fill(grid, 36);
      fill(scopeList, 60);
      if (scopeTitle) {
        scopeTitle.innerHTML = inview.length && dom && counts[dom] / inview.length >= 0.55
          ? esc(dom) + ' <small>· ' + counts[dom] + ' in view</small>'
          : (inview.length ? inview.length + ' cheeses in view' : 'Pan the map to explore');
      }
    }
    var scopeT;
    map.on('moveend zoomend', function () {
      clearTimeout(scopeT);
      scopeT = setTimeout(updateScope, 100);
    });

    /* ---------- panel (optional — section setting can hide it) ---------- */
    var meta = root.querySelector('.csbh-map-meta');
    var countries = {};
    products.forEach(function (p) {
      var c = p.country || 'Other';
      countries[c] = countries[c] || { total: 0, regions: {} };
      countries[c].total++;
      var r = p.region || 'Other';
      countries[c].regions[r] = (countries[c].regions[r] || 0) + 1;
    });
    var countryNames = Object.keys(countries).sort(function (a, b) { return countries[b].total - countries[a].total; });
    if (meta) meta.innerHTML = '<strong>' + products.length + ' cheeses</strong> · ' + countryNames.length + ' countries';

    var browse = root.querySelector('.csbh-map-browse');
    var countryButtons = [], regionButtons = [];
    var openCountry = null;
    function refreshBrowse() {
      countryButtons.forEach(function (b) { b.el.classList.toggle('active', openCountry === b.country); });
      regionButtons.forEach(function (b) { b.el.style.display = openCountry === b.country ? '' : 'none'; });
    }
    if (browse) countryNames.forEach(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'csbh-map-country';
      btn.innerHTML = esc(c) + '<span class="csbh-map-count">' + countries[c].total + '</span>';
      btn.addEventListener('click', function () { focusCountry(c); });
      browse.appendChild(btn);
      countryButtons.push({ country: c, el: btn });

      Object.keys(countries[c].regions).sort().forEach(function (r) {
        var rb = document.createElement('button');
        rb.type = 'button';
        rb.className = 'csbh-map-region';
        rb.style.display = 'none';
        rb.innerHTML = esc(r) + '<span class="csbh-map-count">' + countries[c].regions[r] + '</span>';
        rb.addEventListener('click', function () { focusRegion(c, r); });
        browse.appendChild(rb);
        regionButtons.push({ country: c, region: r, el: rb });
      });
    });

    var resultsEl = root.querySelector('.csbh-map-results');
    var resultsLabel = root.querySelector('.csbh-map-grouplabel-results');
    function renderResults(vis) {
      if (!resultsEl) return;
      resultsEl.innerHTML = '';
      var show = state.query.length >= 2;
      if (resultsLabel) resultsLabel.style.display = show ? '' : 'none';
      if (!show) return;
      if (!vis.length) {
        resultsEl.innerHTML = '<div class="csbh-map-empty">No cheeses match.</div>';
        return;
      }
      vis.slice(0, 40).forEach(function (p) {
        var place = [p.region, p.country].filter(Boolean).join(', ');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'csbh-map-result';
        b.innerHTML = esc(p.title) + (place ? '<small>' + esc(place) + '</small>' : '');
        b.addEventListener('click', function () {
          map.flyTo([p.lat, p.lng], 7, { duration: 0.8 });
          map.once('moveend', function () {
            cluster.zoomToShowLayer(p._marker, function () { p._marker.openPopup(); });
          });
        });
        resultsEl.appendChild(b);
      });
    }

    var search = root.querySelector('.csbh-map-search');
    var t;
    if (search) search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        state.query = search.value.trim();
        render(state.query.length >= 2);
      }, 180);
    });

    var toggle = root.querySelector('.csbh-map-toggle');
    var scroll = root.querySelector('.csbh-map-scroll');
    if (toggle) toggle.addEventListener('click', function () {
      toggle.classList.toggle('open');
      scroll.classList.toggle('open');
    });

    /* ---------- DOM Society seasons (optional; driven by "season" blocks) ---------- */
    function initSeasons() {
      var el = document.getElementById('csbh-map-seasons');
      if (!el) return;
      var data;
      try { data = JSON.parse(el.textContent); } catch (e) { console.error('[csbh-map] seasons JSON invalid', e); return; }
      var seasons = (data.seasons || []).map(function (s) {
        s.lat = parseFloat(s.lat); s.lng = parseFloat(s.lng); return s;
      }).filter(function (s) { return isFinite(s.lat) && isFinite(s.lng) && s.region; });
      if (!seasons.length) return;
      var items = data.items || [];
      var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var fleur = root.dataset.fleurUrl ? '<img src="' + esc(root.dataset.fleurUrl) + '" alt="">' : '';

      function isNext(s) { return s.state === 'next'; }
      function isJump(url) { return typeof url === 'string' && url.charAt(0) === '#'; }
      /* anchor for a season CTA: in-page "#..." links get data-sb-scroll (smooth scroll, closes the popup) */
      function ctaLink(cls, s, text, arrow) {
        if (!s.cta_url || !text) return '';
        return '<a class="' + cls + '" href="' + esc(s.cta_url) + '"' + (isJump(s.cta_url) ? ' data-sb-scroll' : '') + '>' +
          esc(text) + ' ' + (isJump(s.cta_url) ? '&darr;' : arrow) + '</a>';
      }

      function markerHtml(s) {
        var cls = 'sb-marker ' + (isNext(s) ? 'sb-marker--next sb-marker--above' : 'sb-marker--past sb-marker--below') + (small ? ' sb-marker--s' : '');
        return '<div class="' + cls + '">' +
          '<span class="sb-marker-pulse"></span>' +
          '<span class="sb-marker-disc">' + fleur + '</span>' +
          '<span class="sb-marker-label">' +
            '<span class="sb-marker-eyebrow">' + esc(s.label) + (isNext(s) ? ' &middot; next' : '') + '</span>' +
            '<span class="sb-marker-name">' + esc(s.region) + '</span>' +
            (s.note ? '<span class="sb-marker-note">' + esc(s.note) + '</span>' : '') +
          '</span></div>';
      }

      function popupHtml(s) {
        var thumbs = '';
        if (!isNext(s) && items.length) {
          var shown = items.filter(function (it) { return it.img; }).slice(0, 4);
          thumbs = '<ul class="sb-pop-items">' + shown.map(function (it) {
            return '<li><img src="' + esc(it.img) + (it.img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="' + esc(it.name) + '" loading="lazy"></li>';
          }).join('') + (items.length > shown.length ? '<li class="sb-pop-more">+' + (items.length - shown.length) + '</li>' : '') + '</ul>';
        }
        var link = '';
        if (s.popup_link === 'items' && items.length) {
          link = '<a class="csbh-map-pop-link" href="#sb-items" data-sb-scroll>' + esc(s.cta_text || 'See what was in the box') + ' &darr;</a>';
        } else if (s.popup_link !== 'none') {
          link = ctaLink('csbh-map-pop-link', s, s.cta_text, '&rarr;');
        }
        return '<div class="csbh-map-pop sb-pop">' +
          (s.photo ? '<img src="' + esc(s.photo) + '" alt="' + esc(s.photo_alt) + '" loading="lazy">' : '') +
          '<div class="csbh-map-pop-body">' +
          '<div class="sb-pop-eyebrow">The DOM Society &middot; ' + esc(s.label) + (isNext(s) ? ' &middot; Next' : '') + '</div>' +
          '<div class="csbh-map-pop-title">' + esc(s.popup_title || s.region) + '</div>' +
          (s.popup_copy ? '<p class="sb-pop-copy">' + esc(s.popup_copy) + '</p>' : '') +
          thumbs +
          (s.popup_meta ? '<p class="sb-pop-meta">' + esc(s.popup_meta) + '</p>' : '') +
          link +
          '</div></div>';
      }

      seasons.forEach(function (s) {
        var icon = L.divIcon({ className: 'sb-marker-anchor', html: markerHtml(s), iconSize: [0, 0], iconAnchor: [0, 0] });
        s._marker = L.marker([s.lat, s.lng], { icon: icon, zIndexOffset: 2000, title: s.region });
        if (s.click_through && s.cta_url) {
          /* the marker IS the link: no popup, straight to the CTA (or a smooth in-page jump) */
          s._marker.on('click', function () {
            var t = isJump(s.cta_url) ? document.querySelector(s.cta_url) : null;
            if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); else window.location.href = s.cta_url;
          });
        } else {
          s._marker.bindPopup(function () { return popupHtml(s); }, { closeButton: true });
        }
        s._marker.addTo(map);
      });

      function openIfPopup(s) { if (s._marker.getPopup()) s._marker.openPopup(); }
      function flyToSeason(s) {
        map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 5), { duration: 0.8 });
        map.once('moveend', function () { openIfPopup(s); });
      }
      function flyToAll() {
        var next = seasons.filter(isNext)[0] || seasons[0];
        if (seasons.length === 1) { flyToSeason(next); return; }
        var b = L.latLngBounds(seasons.map(function (s) { return [s.lat, s.lng]; }));
        map.flyToBounds(b, { padding: [90, 90], maxZoom: 5, duration: 0.9 });
        map.once('moveend', function () { openIfPopup(next); });
      }

      /* in-page jumps: scroll cue, rail, popup "see what was in the box ↓" */
      root.addEventListener('click', function (ev) {
        var a = ev.target && ev.target.closest ? ev.target.closest('[data-sb-scroll]') : null;
        if (!a) return;
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        ev.preventDefault();
        map.closePopup();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      /* rail: highlight the section under the viewport middle */
      var rail = root.querySelector('.sb-rail');
      if (rail) {
        var links = Array.prototype.slice.call(rail.querySelectorAll('a'));
        var stops = links.map(function (a) { return { a: a, el: document.querySelector(a.getAttribute('href')) }; }).filter(function (x) { return x.el; });
        var railT;
        function updateRail() {
          var mid = window.innerHeight / 2, current = stops[0];
          stops.forEach(function (x) { if (x.el.getBoundingClientRect().top <= mid) current = x; });
          stops.forEach(function (x) { x.a.classList.toggle('is-active', x === current); });
        }
        window.addEventListener('scroll', function () { clearTimeout(railT); railT = setTimeout(updateRail, 60); }, { passive: true });
        updateRail();
      }

      /* pinned card: sibling of the scope list so updateScope() refills never wipe it */
      var head = root.querySelector('.csbh-map-scope-head');
      if (head) {
        var ordered = seasons.filter(isNext).concat(seasons.filter(function (s) { return !isNext(s); }));
        var pin = document.createElement('div');
        pin.className = 'sb-scopepin';
        pin.innerHTML = fleur + '<span class="sb-scopepin-txt">' +
          (data.pinned_eyebrow ? '<span class="sb-scopepin-e">' + esc(data.pinned_eyebrow) + '</span>' : '') +
          ordered.map(function (s, i) {
            return '<span class="sb-scopepin-row' + (isNext(s) ? '' : ' sb-scopepin-row--past') + '" data-season="' + i + '">' +
              '<span class="sb-scopepin-s">' + esc(s.label) + (isNext(s) ? ' &middot; next' : '') + '</span>' +
              '<span class="sb-scopepin-t">' + esc(s.region) + '</span>' +
              (s.pin_text && s.cta_url ? '<a class="sb-scopepin-l" href="' + esc(s.cta_url) + '"' + (isJump(s.cta_url) ? ' data-sb-scroll' : '') + '>' + esc(s.pin_text) + '</a>' : '') +
              '</span>';
          }).join('') + '</span>';
        pin.querySelectorAll('.sb-scopepin-row').forEach(function (row) {
          row.addEventListener('click', function (ev) {
            if (ev.target && ev.target.closest('a')) return; /* the link navigates */
            flyToSeason(ordered[parseInt(row.getAttribute('data-season'), 10)]);
          });
        });
        head.insertAdjacentElement('afterend', pin);
      }

      /* ribbon "see both on the map" */
      root.querySelectorAll('[data-sb-fly]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          var frame = root.querySelector('.csbh-map-frame');
          if (frame && frame.scrollIntoView) frame.scrollIntoView({ behavior: 'smooth', block: 'start' });
          flyToAll();
        });
      });
    }
    initSeasons();

    map.fitBounds(boundsOf(products), { padding: [40, 40] });
    render(false);
  }
})();
